import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Globe, ChevronDown, Check } from "lucide-react";
import { SUPPORTED_LANGS } from "../i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = SUPPORTED_LANGS.find(l => l.code === (i18n.resolvedLanguage || i18n.language)) || SUPPORTED_LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        data-testid="language-switcher-btn"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-colors hover:bg-white/5"
        style={{ color: "#94A3B8", border: "1px solid #1E3A5F" }}
      >
        <Globe className="w-3.5 h-3.5" />
        {!compact && <span style={{ fontFamily: "'IBM Plex Mono'" }}>{current.flag}</span>}
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-1.5 rounded-lg shadow-2xl py-1 min-w-[160px] z-50 animate-fade-in-up"
          style={{ background: "#0F2035", border: "1px solid #1E3A5F" }}
          data-testid="language-switcher-menu"
        >
          {SUPPORTED_LANGS.map((l) => {
            const isActive = l.code === current.code;
            return (
              <button
                key={l.code}
                data-testid={`lang-option-${l.code}`}
                onClick={() => change(l.code)}
                className="w-full flex items-center gap-2.5 px-3 py-2 text-xs hover:bg-white/5 transition-colors"
                style={{ color: isActive ? "#00D4FF" : "#CBD5E1" }}
              >
                <span className="font-mono text-[10px] px-1.5 py-0.5 rounded" style={{ background: "rgba(255,255,255,0.04)", color: "#94A3B8" }}>
                  {l.flag}
                </span>
                <span className="flex-1 text-left">{l.label}</span>
                {isActive && <Check className="w-3.5 h-3.5" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
